'use client'
import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

/** Same lines as `UtilizationTableClient`: 44 px each when stacked, stretched to the chart beside it. */
const UtilizationTableLoading = () => {
  return (
    <DataList.Root>
      <DataList.Column>
        {Array.from({ length: 4 }, (_, index) => (
          <DataList.Line key={index} className="lg:h-auto lg:flex-1">
            <Skeleton className="h-md w-[100%] rounded-[20px]" />
          </DataList.Line>
        ))}
      </DataList.Column>
    </DataList.Root>
  )
}

export default UtilizationTableLoading
